export function characterCounts(text) {
  const counts={};
  for (const char of text) if (/\p{Script=Han}|\p{Script=Hiragana}|\p{Script=Katakana}|[ー々]/u.test(char)) counts[char]=(counts[char]||0)+1;
  return counts;
}
export function parseMarkedText(marked,deck){
  const byWord=new Map(deck.map(w=>[w.word,w])), tokens=[],wordCounts={};
  for(const w of deck) if(!byWord.has(w.reading)&&deck.filter(x=>x.reading===w.reading).length===1) byWord.set(w.reading,w);
  let cursor=0,text='';
  for(const match of marked.matchAll(/\[\[([^\]]+)\]\]/g)){
    const prefix=marked.slice(cursor,match.index);if(prefix){tokens.push({text:prefix});text+=prefix;}
    const [key,surface]=match[1].split('|'),word=byWord.get(key);
    if(!word)throw new Error('Unknown deck word: '+key);
    const value=surface||key;tokens.push({text:value,wordId:word.id});text+=value;wordCounts[word.id]=(wordCounts[word.id]||0)+1;cursor=match.index+match[0].length;
  }
  const suffix=marked.slice(cursor);if(suffix){tokens.push({text:suffix});text+=suffix;}
  return {text,tokens,wordCounts,characterCounts:characterCounts(text)};
}
export function newExposure(){return {since:Date.now(),words:{},characters:{},stories:{}};}
function emptyWord(){return {storyAudio:0,studyAudio:0,storyReads:0,studyReads:0,reviews:0,audioPlays:0};}
function emptyCharacter(){return {storyAudio:0,studyAudio:0,storyReads:0,studyReads:0,reviews:0,audioPlays:0};}
export function addExposure(exposure,{source,kind,wordCounts={},characterCounts:chars={},review=false}){
  const field=source+(kind==='audio'?'Audio':'Reads');
  for(const [id,count] of Object.entries(wordCounts)){
    const row=exposure.words[id] ||= emptyWord();row[field]+=count;
    if(kind==='audio')row.audioPlays++;if(review)row.reviews++;
  }
  for(const [char,count] of Object.entries(chars)){
    const row=exposure.characters[char] ||= emptyCharacter();row[field]+=count;
    if(kind==='audio')row.audioPlays++;if(review)row.reviews++;
  }
}
export function exposureTotals(row){
  const r=row||emptyWord();const audio=r.storyAudio+r.studyAudio,reading=r.storyReads+r.studyReads;
  return {audio,reading,score:audio+reading,reviews:r.reviews,plays:r.audioPlays};
}
export function storyWordCounts(story){
  const counts={};for(const sentence of story.sentences)for(const [id,n] of Object.entries(sentence.wordCounts))counts[id]=(counts[id]||0)+n;return counts;
}
